module.exports = __webpack_public_path__ + "img/postcard@2x.08ecc8b3.jpg";